<template>
  <div class="page-shell">
    <BackToProjects />
    <!-- Title Section -->
    <div class="text-center mb-10">
      <h1 class="text-4xl font-bold mb-4">Python API - Bayesian Knowledge Tracing</h1>
    </div>

    <div class="mb-8">
      <h2 class="text-2xl font-semibold mb-2">The project</h2>
      <p class="text-gray-700">
        This was a multi-faceted project aimed at PHD research of BKT - Bayesian Knowledge Tracing applied to Moodle learning. The project involved:
      </p>
    </div>

    <div class="mb-8">
      <p class="text-gray-700 mb-4">
        <ul class="list-disc pl-5 text-gray-700">
          <li>A <a href="https://kristian-94.github.io/logbook" target="_blank" rel="noopener">Flask</a> Python API contained in Docker to do the heavy lifting of BKT analysis</li>
          <li>Developing and hosting a Moodle site for ~100 students for a semester of quiz data</li>
        </ul>
      </p>
      <br>
      <h2 class="text-2xl font-semibold mb-2">Details</h2>

      <p>
        We used the <a href="https://github.com/CAHLR/pyBKT" target="_blank" rel="noopener">pyBKT</a> library to do the heavy lifting of BKT analysis. The library was wrapped in a Flask API and hosted in a Docker container. The API was then called from the Moodle site to do the analysis of the quiz data.
      </p>

      <p>The idea with this approach is to firstly have a normal quiz which collects data. This data is then used to train a model to predict how well the student understands the content.</p>
      <p>The next part is to use that model in a new quiz where the goal is to only end the quiz when the student actually understands the content. This means we take the model and calculate mastery after each question. Mastery is a number from 0 -> 1 and we end the quiz at a configurable point, by default 0.95.</p>

      <p>
        In Moodle, we developed two plugins:
      </p>
      <ul class="list-disc pl-5 text-gray-700">
        <li>A quiz reporting plugin that can take data from a quiz and train a BKT Model</li>
        <li>A new BKT quiz based off the <a href="https://github.com/vtos/moodle-mod_adaptivequiz" target="_blank" rel="noopener">adaptive quiz</a> plugin with the ability to end the quiz only after the student reaches mastery.</li>
      </ul>
      <br>
      <h2 class="text-2xl font-semibold mb-2">Result</h2>
      <p>
        The project was a success and the PHD student was able to use the data to further their research.
      </p>

      <br>
      <hr>
      <br>
      <div class="featured-image mb-8 flex justify-center">
        <img src="/bkt-classroom.png" alt="Classroom illustration for the Bayesian Knowledge Tracing project" class="md:w-full lg:w-1/2 h-auto">
      </div>
    </div>
  </div>
</template>

<style>
/* Tailwind CSS handles most of the styling; add any additional custom styles here */
</style>
<script setup lang="ts">
</script>